import React from 'react';

import InputField from '../../blocks/inputField/InputField';
import Button from '../../blocks/button/Button';
// import Checkbox from '../../blocks/checkbox/Checkbox';

import { newEmailHandler }from '../../validators/form-validators';
import FormSubmitAgreement from '../../blocks/form-blocks/FormSubmitAgreement';

export const ALREADY_REGISTERED = 'already_registered';
export const NOT_REGISTERED = 'not_registered';

export default class SubscribeToNews extends React.Component {


  render() {

    const {
      registrationStatus,
      onSubmit,
      submitDisabled,
    } = this.props;

    const contentByRegistrationStatus = {
      [NOT_REGISTERED]: (
          <form
            className='participant-form'
            onSubmit={onSubmit.bind(this, 'participant')}
            disabled={submitDisabled}
          >
            <div className='participant-form__field'>
              <InputField
                name='entry.1212922480'
                tabIndex={1}
                onValidate={newEmailHandler}
                ref='participantEmail'
                placeholder={'Оставьте свой Email'}
              />
            </div>
            <Button
              styleClasses={['participant-form__submit-btn']}
            >
              Подписаться на новости
            </Button>
            <FormSubmitAgreement/>
          </form>
        ),
      [ALREADY_REGISTERED]: (
          <div className='participant-form_success'>Спасибо за регистрацию!</div>
        )
    };

    return (
      <div>
        { contentByRegistrationStatus[registrationStatus] }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/landing/blocks/SubscribeToNews.js